import React from 'react';

import Favorites from '~containers/favorites';
// import Payments from '~containers/payments';
import Chats from '~containers/chats';
import Operations from '~containers/operations';
import EditWish from '~containers/wishes/edit';
import Account from '~containers/account';
import Settings from '~containers/settings';
import Discussion from '~containers/discussion';
import Review from '~containers/review';
// import PaymentProcess from '~containers/payment/process';
import PaymentProcess from '~containers/payment/subscription-process';

import ProtectedRoute from './protected-route';

const InternalRoutes = () => {
  return (
    <>
      <ProtectedRoute exact path="/favorites" forScope={['client', 'worker']}>
        <Favorites />
      </ProtectedRoute>
      {/* <ProtectedRoute exact path="/payments">
        <Payments forScope={['client']} />
      </ProtectedRoute> */}
      <ProtectedRoute exact path="/chats" forScope={['client', 'worker']}>
        <Chats />
      </ProtectedRoute>
      <ProtectedRoute exact path="/edit-offer" forScope={['worker']}>
        <Operations />
      </ProtectedRoute>
      <ProtectedRoute exact path="/edit-wish" forScope={['client']}>
        <EditWish />
      </ProtectedRoute>
      <ProtectedRoute exact path="/account" forScope={['client', 'worker']}>
        <Account />
      </ProtectedRoute>
      <ProtectedRoute exact path="/settings" forScope={['client', 'worker']}>
        <Settings />
      </ProtectedRoute>
      <ProtectedRoute path="/discussion/:recipientId" forScope={['client', 'worker']}>
        <Discussion />
      </ProtectedRoute>
      <ProtectedRoute exact path="/review/:receiverId" forScope={['client', 'worker']}>
        <Review />
      </ProtectedRoute>
      {/* <ProtectedRoute exact path="/payment/process" forScope={['client']}>
        <PaymentProcess />
      </ProtectedRoute> */}
      <ProtectedRoute exact path="/payment/process" forScope={['client']}>
        <PaymentProcess />
      </ProtectedRoute>
      {/* <ProtectedRoute exact path="/workers" forScope={['client']}>
        <Workers />
      </ProtectedRoute>
      <ProtectedRoute exact path="/customers" forScope={['worker']}>
        <Customers />
      </ProtectedRoute> */}
    </>
  );
};

export default InternalRoutes;
